
export const RECEIVE_ALL_DATA = "RECEIVE_ALL_DATA"
export const ADD_MENU = "ADD_MENU"
export const DELETE_MENU = "DELETE_MENU"
export const MOVE_MENU = "MOVE_MENU"
export const DROP_MENU = "DROP_MENU"
export const AFTER_SAVE = "AFTER_SAVE"
